import { render } from "./UrlBackAndForth.vue?vue&type=template&id=0aea1fa4&ts=true"
import script from "./UrlBackAndForth.vue?vue&type=script&lang=ts"
export * from "./UrlBackAndForth.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__